import { render, staticRenderFns } from "./couponType.vue?vue&type=template&id=4647cfa2&scoped=true&"
import script from "./couponType.vue?vue&type=script&lang=js&"
export * from "./couponType.vue?vue&type=script&lang=js&"
import style0 from "./couponType.vue?vue&type=style&index=0&id=4647cfa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647cfa2",
  null
  
)

export default component.exports